import { writable } from 'svelte/store';

export const isMobile = writable(null);
export const selSystem = writable(null);
export const selCounty = writable(null);
